<template>
<div>
  <router-link :to="'/sub/glass/single/'+newsItem.id" class="text-decoration-none">
    <v-row  class="card white rounded my-4">
      <v-col cols="12" xl="3" lg="3" class="text-center">
        <img width="80%" height="140" :src="newsItem.photo_file" alt="">
      </v-col>
      <v-col cols="12" xl="7" lg="7" class="text-right">
        <h6 class="font-weight-bold mb-3 mt-4">{{ newsItem.title }}</h6>
        <div dir="auto" style="line-height: 1.5em;
    height: 3em;
    overflow: hidden;" v-html="newsItem.details"></div>
        <!--      <p class="grey&#45;&#45;text">{{ newsItem.subTitle }}</p>-->
        <!--      <div class="skewBox">{{ newsItem.hashtag }}</div>-->
      </v-col>
      <v-col class="my-6 my text-right" cols="12" xl="2" lg="2">
        <div  style="width: 60%" class="gray ma-auto pa-4 d-flex flex-column align-center justify-center HOVER t-box">
          <span></span>
          <div class="date-box">{{ newsItem.date }}</div>
          <div class="d-flex align-center justify-center">
            {{ newsItem.visits+1000 }}
            <v-icon class="mx-1" small>mdi-eye</v-icon>
          </div>

        </div>
      </v-col>
    </v-row>
  </router-link>

</div>
</template>

<script>
export default {
  name: "BlockNewsItem",
  props:{
    newsItem:Object
  }
}
</script>

<style scoped>
.skewBox {
  margin-top: 12px;
  display: inline-block;
  padding: 12px;
  background-color: #e8ebf0;
  color: #8198c2 !important;
  transform: skew(
      -13deg, 0);
  -webkit-transform: skew(
      -13deg, 0);
  -moz-transform: skew(-13deg, 0);
  -o-transform: skew(-13deg, 0);
}

.date-box {
  border-bottom: 1px solid #dcdcdc;
  width: 100%;
  font-size: 14px;
  margin-bottom: 7px;
}
.card{
  min-height: 164px;
}
.card:hover{
  transition: all 0.1s cubic-bezier(0.7, 0.01, 0.3, 1);
  box-shadow: -1px 1px 16px -3px #00000038;
}
/*.card:hover>.my>.t-box{*/
/*  display: block;*/
/*  position: relative;*/
/*  box-sizing: border-box;*/
/*  background: #0846be !important;*/
/*  color: white !important;*/
/*  transition: all 0.3s cubic-bezier(0.7, 0.01, 0.3, 1);*/
/*  animation: colored ease-in 3s;*/
/*}*/

.card:hover>.my>.t-box>*{
  color: white;
  z-index: 99;
  transition: all 0.3s cubic-bezier(0.7, 0.01, 0.3, 1);
}
.card:hover>.my>.t-box>*>*{
  color: white;
  transition: all 0.3s cubic-bezier(0.7, 0.01, 0.3, 1);
}




@keyframes shake {
  25% {
    transform: rotate(calc(var(--angle) * -1));
  }

  50% {
    transform: rotate(var(--angle));
  }

  100% {
    transform: rotate(0deg);
  }
}

body {
  font: 100 1.3em sans-serif;
  display: flex;
  flex-direction: column;
  align-content: center;
  padding: 0 5rem;
}

h1 {
  font-weight: 100;
}

.display {
  display: grid;
  grid-template-columns: 50% 50%;
  gap: 0.1em;
}

.HOVER {
  --width: 100%;
  --time: 0.7s;

  position: relative;
  display: inline-block;
  padding: 1em;

  color: white;
  background: #222;
  overflow: hidden;
}

.HOVER text {
  position: relative;
  z-index: 5;

  transition: color var(--time);
}

.HOVER:hover text {
  color: #222;
}

.card:hover>.my>.HOVER span {
  position: absolute;
  display: block;
  content: "";
  z-index: 0;
  width: 0;
  height: 0;
  border-radius: 100%;
  background: #7BAD32;
  transform: translate(2%, -48%);
  transition: width var(--time), padding-top var(--time);
}

.card:hover>.my>.HOVER span {
  width: calc(var(--width) * 12.25);
  padding-top: calc(var(--width) * 28.25);
}

</style>